export type LandingNavigationChild = {
  label: string;
  href: string;
};

export type LandingNavigationItem = {
  label: string;
  /** Omitted for the section parents, those have no index page, only children. */
  href?: string;
  children: LandingNavigationChild[];
};

/* Mirrors the nav in the redesigned template (`LightShipSmart/*.html`): no Home entry,
   the logo carries it, and Technology is its own group. Resources remains folded into
   Company so the requested Industries group can use the sixth desktop menu slot. */
export const landingNavigation: LandingNavigationItem[] = [
  {
    label: 'Shippers',
    children: [
      ['Managed Transportation', '/shippers/managed-transportation'],
      ['Freight Brokerage', '/shippers/freight-brokerage'],
      ['Warehousing', '/shippers/warehousing'],
      ['Dedicated Capacity', '/shippers/dedicated-capacity'],
      ['Capacity Solutions', '/shippers/capacity-solutions'],
      ['Project Logistics', '/shippers/project-logistics'],
      ['International Logistics', '/shippers/international-logistics'],
    ].map(([label, href]) => ({ label, href })),
  },
  {
    label: 'Carriers',
    children: [
      ['Become a Carrier', '/carriers/become-a-carrier'],
      ['Available Loads', '/carriers/available-loads'],
      ['Carrier Setup Packet', '/carriers/carrier-setup-packet'],
      ['Insurance Requirements', '/carriers/insurance-requirements'],
      ['Carrier Benefits', '/carriers/carrier-benefits'],
    ].map(([label, href]) => ({ label, href })),
  },
  {
    label: 'Services',
    children: [
      ['Full Truckload (FTL)', '/services/full-truckload'],
      ['Less Than Truckload (LTL)', '/services/less-than-truckload'],
      ['Partial Truckload (PTL)', '/services/partial-truckload'],
      ['Dry Van', '/services/dry-van'],
      ['Flatbed', '/services/flatbed'],
      ['Reefer', '/services/reefer'],
      ['Heavy Haul', '/services/heavy-haul'],
      ['Intermodal', '/services/intermodal'],
      ['Drayage', '/services/drayage'],
      ['Expedited', '/services/expedited'],
      ['Last Mile Delivery', '/services/last-mile-delivery'],
      ['Sustainable Logistics', '/services/sustainable-green-logistics'],
    ].map(([label, href]) => ({ label, href })),
  },
  {
    label: 'Industries',
    children: [
      ['Manufacturing', '/industries/manufacturing'],
      ['Food & Beverage', '/industries/food-beverage'],
      ['Retail / E-commerce', '/industries/retail-ecommerce'],
      ['Construction', '/industries/construction'],
      ['Automotive', '/industries/automotive'],
      ['Government', '/industries/government'],
      ['Pharma', '/industries/pharmaceutical'],
      ['Technology', '/industries/technology-electronics'],
      ['Packaging', '/industries/packaging'],
    ].map(([label, href]) => ({ label, href })),
  },
  {
    label: 'Technology',
    children: [
      ['Real-Time Tracking', '/company/real-time-tracking'],
      ['Shipment Visibility', '/company/shipment-visibility'],
      ['Digital Freight Management', '/company/digital-freight-management'],
    ].map(([label, href]) => ({ label, href })),
  },
  {
    label: 'Company',
    children: [
      ['About Us', '/company/about'],
      ['Carrier Network', '/company/carrier-network'],
      // Hidden until the Case Studies section is ready to be published.
      // ['Case Studies', '/company/case-studies'],
      ['Locations', '/company/locations'],
      ['Blog', '/company/news'],
      ['Shipping Guides', '/company/guides'],
      ['FAQ', '/company/faq'],
    ].map(([label, href]) => ({ label, href })),
  },
];
